import * as types from "./mutation_types";

const URL_BACKEND = process.env.VUE_APP_URL_BACKEND;
import axios from "@/lib/axioxAppli";

export const getItems = ({ commit }) => {
  commit(types.CARTE_TOGGLE_LOADING);

  axios
    .get(URL_BACKEND + "api-carte/")
    .then((response) => {
      commit(types.CARTE_TOGGLE_LOADING);
      commit(types.CARTE_SET_ITEMS, response.data);
    })
    .catch((e) => {
      commit(types.CARTE_SET_ITEMS, []);
      commit(types.CARTE_TOGGLE_LOADING);
      commit(types.CARTE_SET_ERROR, e.message);
    });
};
